/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function RoomsField (props: FormNumberFieldProps) {
  const { name = 'rooms', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'rooms',
        defaultMessage: 'Pièces'
      })}
      name={name}
      parser={parseNumber}
      {...others}
    />
  )
}

export default RoomsField
